import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import styles from "./OurTeam.module.css";

const teamMembers = [
  {
    name: "Dhruv Mohan",
    designation: "CEO & Founder",
    imgURL: "./assets/team/Dhruv_Mohan.JPG",
  },
  {
    name: "Isha Gupta",
    designation: "Chief AI Officer",
    imgURL: "./assets/team/Isha_Gupta.JPG",
  },
  {
    name: "Anil Kumar",
    designation: "Director of Operations",
    imgURL: "./assets/team/Anil_Kumar.JPG",
  },
  
];

const responsive = {
  superLargeDesktop: { breakpoint: { max: 4000, min: 1024 }, items: 3 },
  desktop: { breakpoint: { max: 1024, min: 768 }, items: 2 },
  tablet: { breakpoint: { max: 768, min: 464 }, items: 1 },
  mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
};

const OurTeam = () => {
  return (
    <div
      style={{
        background: `url(./assets/team/Office_Grp2.JPG)`,
        backgroundSize: "cover",
        backgroundPosition: "10% 20%",
        position: "relative",
        top: "-30px",
        backgroundAttachment: "fixed",
      }}
    >
      <div id="team" className={styles.container}>
        <p className={styles.animation}>Our Team</p>

        <div className={styles.carousel_wrapper}>
          <Carousel
            responsive={responsive}
            infinite
            autoPlay
            autoPlaySpeed={3000}
          >
            {teamMembers.map((member, index) => (
              <div key={index} className={styles.teamMemberCard}>
                <div className={styles.imageContainer}>
                  <img
                    src={member.imgURL}
                    alt={member.name}
                    className={styles.memberImage}
                  />
                  <div className={styles.imageDarkOverlay}></div>
                </div>
                <div className={styles.memberInfo}>
                  <h3>{member.name}</h3>
                  <p>{member.designation}</p>
                </div>
              </div>
            ))}
          </Carousel>
        </div>
      </div>
    </div>
  );
};

export default OurTeam;
